import { Component, Input, OnInit } from '@angular/core';
import * as Diff from 'diff';
import { StringUtil } from 'src/app/shared/util/string.util';

@Component({
	selector: 'app-visualizar-diferencas',
	templateUrl: './visualizar-diferencas.component.html',
	styleUrls: ['./visualizar-diferencas.component.css']
})
export class VisualizarDiferencasComponent implements OnInit {

	@Input() idAtoBase: number;
	@Input() conteudoEsquerda: string;
	@Input() conteudoDireita: string;

	linhas1: LinhaDiferenca[];
	linhas2: LinhaDiferenca[];

	diffResult1: TextoDiferenca[] = [];
	diffResult2: TextoDiferenca[] = [];

	ngOnInit(): void {

		const diff = Diff.diffWordsWithSpace(this.conteudoEsquerda, this.conteudoDireita);

		const result1: TextoDiferenca[] = [];
		const result2: TextoDiferenca[] = [];

		let tempText1 = '';
		let tempText2 = '';
		let lastType: 'adicionado' | 'removido' | 'none' = 'none';

		diff.forEach(part => {

			if (part.added) {
				if (lastType === 'removido') {
					result1.push({ texto: tempText1, removido: true });
					tempText1 = '';
				}
				tempText2 += part.value;
				lastType = 'adicionado';

			} else if (part.removed) {
				if (lastType === 'adicionado') {
					result2.push({ texto: tempText2, adicionado: true });
					tempText2 = '';
				}
				tempText1 += part.value;
				lastType = 'removido';

			} else {
				if (tempText1) {
					result1.push({ texto: tempText1, removido: true });
					tempText1 = '';
				}
				if (tempText2) {
					result2.push({ texto: tempText2, adicionado: true });
					tempText2 = '';
				}
				result1.push({ texto: part.value });
				result2.push({ texto: part.value });
				lastType = 'none';
			}
		});

		if (tempText1) {
			result1.push({ texto: tempText1, removido: true });
		}
		if (tempText2) {
			result2.push({ texto: tempText2, adicionado: true });
		}

		this.diffResult1 = this.groupContiguousDifferences(result1);
		this.diffResult2 = this.groupContiguousDifferences(result2);

		this.linhas1 = this.separarDiffEmLinhas(this.diffResult1);
		this.linhas2 = this.separarDiffEmLinhas(this.diffResult2);
	}

	separarDiffEmLinhas(diff: TextoDiferenca[]): LinhaDiferenca[] {

		let linhas: LinhaDiferenca[] = [];
		let linhaAtual = new LinhaDiferenca();

		diff.forEach(textoDiferenca => {

			if (StringUtil.contemQuebraLinha(textoDiferenca.texto)) {

				const linhasQuebradas = StringUtil.quebrarTextoEmLinhas(textoDiferenca.texto);
				linhaAtual.textos.push({ 'texto': linhasQuebradas[0], 'removido': textoDiferenca.removido, 'adicionado': textoDiferenca.adicionado });

				for (let i = 1; i < linhasQuebradas.length; i++) {
					linhas.push(linhaAtual);

					linhaAtual = new LinhaDiferenca();
					if (linhasQuebradas[i].trim() !== '') {
						linhaAtual.textos.push({ 'texto': linhasQuebradas[i], 'removido': textoDiferenca.removido, 'adicionado': textoDiferenca.adicionado });
					}
				}

			} else {
				linhaAtual.textos.push(textoDiferenca);
			}
		});

		linhas.push(linhaAtual);

		linhas = this.definirLinhasAlteradas(linhas);

		return linhas;
	}

	definirLinhasAlteradas(linhas: LinhaDiferenca[]): LinhaDiferenca[] {

		linhas.forEach(linha => {
			if (linha.textos.some(t => t.adicionado === true || t.removido === true)) {
				linha.alterada = true;
			}
		});

		return linhas;
	}

	groupContiguousDifferences(diffArray: TextoDiferenca[]) {

		const groupedArray: TextoDiferenca[] = [];
		let tempText = '';
		let currentType: 'adicionado' | 'removido' | null = null;

		diffArray.forEach(part => {

			if ((part.removido && currentType === 'removido') || (part.adicionado && currentType === 'adicionado')) {
				tempText += part.texto;

			} else {
				if (tempText) {
					// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
					groupedArray.push({ texto: tempText, [currentType!]: true });
					tempText = '';
				}
				if (part.removido || part.adicionado) {
					tempText = part.texto;
					currentType = part.removido ? 'removido' : 'adicionado';
				} else {
					groupedArray.push(part);
					currentType = null;
				}
			}
		});

		if (tempText) {
			// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
			groupedArray.push({ texto: tempText, [currentType!]: true });
		}

		return groupedArray;
	}
}

export class TextoDiferenca {
	texto: string;
	removido? = false;
	adicionado? = false;
}

export class LinhaDiferenca {
	alterada? = false;
	textos: TextoDiferenca[] = [];
}